import {
  CATALOG_GENRE_DETAIL_SET_DATA,
  CATALOG_GENRE_DETAIL_RESET_DATA,
} from 'rebook/apps/catalog/constants';


const initialState = {
  genre: null,
  books: null,
  paginateBy: 18,
  pageNumber: 1,
  lastPageNumber: 0,
  orderBy: 'popular',
  subscriptionId: null,
  totalBookCount: null,
  similarGenres: null,
  bookType: null,
};

export default function genreDetail(state = initialState, action) {
  switch (action.type) {
    case CATALOG_GENRE_DETAIL_SET_DATA:
      return {
        ...state,
        ...action.payload,
      };
    case CATALOG_GENRE_DETAIL_RESET_DATA:
      return initialState;
    default:
      return state;
  }
}
